// src/utils/messages.ts

export const MESSAGES = {
  success: {
    login: 'Login successful!',
    adminLogin: 'Admin login successful!',
    otpSent: 'OTP sent to your email',
    otpVerified: 'OTP verified',
    passwordReset: 'Password reset successful',
    resetLinkSent: 'If the email exists, a reset link has been sent',
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
  },
  error: {
    invalidCredentials: 'Invalid email or password',
    credentialsError: 'Invalid credentials',
    invalidLoginPortal: 'Invalid login portal. Please use the correct login page for your role.',
    accountBlocked: 'Your account has been blocked. Please contact administrator.',
    failedToSendOtp: 'Failed to send OTP',
    failedToSendResetLink: 'Failed to send reset link',
    invalidOrExpiredOtp: 'Invalid or expired OTP',
    passwordResetFailed: 'Password reset failed',
    passwordMismatch: 'Passwords do not match',
    expiredResetLink: 'Reset link has expired. Please request a new one.',
    invalidResetLink: 'Invalid reset link. Please request a new one.',
  },
  info: {
    needsPasswordReset: 'Please set your password to continue',
  },
  validation: {
    required: (label: string) => `${label} is required`,
    invalidEmail: 'Enter a valid email address',
    // invalidPassword: 'Password must be at least 8 characters with uppercase, lowercase, number, and special character (!@#$%^&*)',
    invalidPassword: {
      missing: 'Password is required',
      minLength: 'Password must be at least 8 characters long',
      uppercase: 'Password must contain at least one uppercase letter',
      lowercase: 'Password must contain at least one lowercase letter',
      number: 'Password must contain at least one number',
      specialChar: 'Password must contain at least one special character',
    },
    invalidOtp: 'OTP must be exactly 6 digits',
    invalidName: 'Name must be 2-100 characters (letters, spaces, hyphens, apostrophes)',
    invalidLicence: 'Licence number must be 4-20 alphanumeric characters or hyphens',
    passwordMismatch: 'Passwords do not match',
  },
} as const;
